import React, {useState, useEffect} from 'react';
import {useDispatch} from "react-redux";
import DataGrid, {
    Column,
    FilterRow, 
    ColumnChooser,
    Paging,
    Pager, 
} from 'devextreme-react/data-grid';
import Request from "../../components/api/Request";
import {Button} from 'devextreme-react/button';
import DateBox from 'devextreme-react/date-box';
import { CheckBox } from 'devextreme-react/check-box';
import 'devextreme/data/odata/store';
import CustomStore from 'devextreme/data/custom_store';
import * as Utils from '../../utils/Utils';
import {parseDate} from "../../utils/Utils";
import DropDownBox from 'devextreme-react/drop-down-box';
import TreeView from 'devextreme-react/tree-view'; 
import {Popup} from 'devextreme-react/popup';
import './TesvikDetayIslemleri.scss'
import { showDialog, showToast } from "../../utils/Utils";
import { ToastType } from "../../constants/Constants";
import TesvikLoginIslemleri from '../sgklogin/TesvikLoginIslemleri';
import * as AppActions from '../../actions/AppActions';

const TesvikDetayIslemleri = (props) => {

    const dispatch = useDispatch();

    const listeBasligi = "Teşvik Detayları";

    const [formYetki, setFormYetki] = useState(
        {
            sgkLogin: Utils.hasRole("tesvik|tesvikislemleri|sgkLogin"), 
            onayliDonemIndir: Utils.hasRole("tesvik|tesvikislemleri|onayliDonemIndir"), 
            donemIndir: Utils.hasRole("tesvik|tesvikislemleri|donemIndir"), 
            tumPersonelleriSorgula: Utils.hasRole("tesvik|tesvikislemleri|tumPersonelleriSorgula"), 
            tesvikKaydet: Utils.hasRole("tesvik|tesvikislemleri|tesvikKaydet"), 
            tekTesvikSil: Utils.hasRole("tesvik|tesvikislemleri|tekTesvikSil") ,
            tesvikDetayIslemleri: Utils.hasRole("tesvik|tesvikDetayIslemleri|listele") ,
            tesvikTarihGuncelle:
                Utils.hasRole("tesvik|tesvikDetayIslemleri|tesvikTarihGuncelle")
                || Utils.hasRole("tesvikDetayIslemleri|tesvikTarihGuncelle"),
        });

    const [treeBoxValue, setTreeBoxValue] = useState([]);
    const [treeDataSource, setTreeDataSource] = useState([]);
    const [store, setStore] = useState(null);
    const [donemDataValue, setDonemDataValue] = useState([]);
    const [donemDataSource, setDonemDataSource] = useState([]);
    const [filterMap , setFilterMap]  = useState(null);

   
    useEffect(() => {
        setStore(new CustomStore({key:'id'}));
        setFilterMap(Utils.getFilterMap(dataGrid));
    }, [])

    useEffect(() => {
        if (filterMap) {
            domainListYukle();
            donemListYukle();
            setStore(getStore());
        }
    }, [filterMap])

    const domainListYukle = () => {

        const request = new Request("/userDomain/getUserDomainList", "GET");

        request.run()
            .then(response => {
                if (response.data) {
                    setTreeDataSource(response.data.data);
                } else {
                    return []

                }
            });
    }

    const donemListYukle = () => {

        const request = new Request("/donem/getKayitList", "GET");

        request.run()
            .then(response => {
                if (response.data) {
                    setDonemDataSource(response.data.data);
                } else {
                    return []
                }
            });
    }

    let dataGrid = null;
    let treeView = null;
    const [tesvikDetayData, setTesvikDetayData] = useState({popupState: false, data: {}});
    function hideTesvikSgkPopup() {
        setTesvikDetayData({popupState: false, data: {}})
    }
    function showTesvikSgkPopup(data) {
        setTesvikDetayData({
            popupState: true,
            data: data
        });
    }

    const [tarihGuncelleState, setTarihGuncelleState] = useState({
        popupState: false,
        id: null,
        baslangicDonemi: null,
        bitisDonemi: null,
        emekli: null,
    });

    function formatTesvikDonemForApi(d) {
        if (d == null || !(d instanceof Date) || isNaN(d.getTime())) {
            return null;
        }
        const pad = (n) => String(n).padStart(2, "0");
        return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    }

    function hideTarihGuncellePopup() {
        setTarihGuncelleState({
            popupState: false,
            id: null,
            baslangicDonemi: null,
            bitisDonemi: null,
            emekli: null,
        });
    }

    function showTarihGuncellePopup(row) {
        const b = row.baslangicDonemi;
        const bit = row.bitisDonemi;
        setTarihGuncelleState({
            popupState: true,
            id: row.id,
            baslangicDonemi: b instanceof Date ? new Date(b.getTime()) : null,
            bitisDonemi: bit instanceof Date ? new Date(bit.getTime()) : null,
            emekli: row.personelTesvik?.emekli ?? null,
        });
    }

    function kaydetTesvikTarih() {
        const payload = {
            id: tarihGuncelleState.id,
            baslangicDonemi: formatTesvikDonemForApi(tarihGuncelleState.baslangicDonemi),
            bitisDonemi: formatTesvikDonemForApi(tarihGuncelleState.bitisDonemi),
            emekli: tarihGuncelleState.emekli,
        };
        const request = new Request("/tesvikDetayIslemleri/update-tesvik-tarih", "POST", payload);
        dispatch(AppActions.setLoading(true, " Teşvik tarihleri güncelleniyor..."));
        request.run()
            .then((response) => {
                if (response && response.data && response.data.success !== false) {
                    showToast("Teşvik tarihleri güncellendi", ToastType.SUCCESS, 1500);
                    hideTarihGuncellePopup();
                    yenile();
                }
            })
            .finally(() => {
                dispatch(AppActions.setLoading(false, ""));
            });
    }

    const getStore = () => {
        return new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) {

                console.log("loadOptions",loadOptions);
                if(loadOptions.searchOperation == undefined){
                    return;
                }

                let filterArr = [];

                if (treeBoxValue.length > 0) {
                    filterArr.push({
                        property: "personelTesvik.domain.id",
                        operator: "IN",
                        value: treeBoxValue,
                        type: "Long"
                    })
                }
                if (props.data) {
                    filterArr.push({
                        property: "personelTesvik.domain.id",
                        operator: "=",
                        value: props.data.domainId,
                        type: "Long"
                    });
                    filterArr.push({
                        property: "personelTesvik.donem.id",
                        operator: "=",
                        value: props.data.donemId,
                        type: "Long"
                    });
                }

                let params = Utils.getGridLoadOptionsParams(loadOptions, filterMap, filterArr);

                const request = new Request("/tesvikDetayIslemleri/getKayitList" + params, "GET");

                return request.run()
                    .then(response => {

                        response.data.data.map(d => {
                            d.baslangicDonemi = parseDate(d.baslangicDonemi);
                            d.bitisDonemi = parseDate(d.bitisDonemi); 
                            d.personelTesvik.iseGirisTarihi = parseDate(d.personelTesvik.iseGirisTarihi);
                        });

                        if (response.data) {
                            return {
                                data: response.data.data,
                                totalCount: response.data.total,
                                summary: 0,
                                groupCount: 0
                            };
                        } else {
                            return []

                        }
                    });
            }
        });
    }
 
    const syncTreeViewSelection = (e) => {
        let tree = (e.component.selectItem && e.component) || (treeView && treeView.instance);

        if (tree) {
            if (e.value === null) {
                tree.unselectAll();
            } else {
                let values = e.value || treeBoxValue;
                values && values.forEach(function (value) {
                    tree.selectItem(value);
                });
            }
        }

        if (e.value !== undefined) {
            if (e.value == null) {
                setTreeBoxValue([]);
            } else {
                setTreeBoxValue(e.value);
            }
        }
    }

    const treeView_itemSelectionChanged = (e) => {
        setTreeBoxValue(e.component.getSelectedNodeKeys());
    }

    const treeViewRender = () => {
        return (
            <TreeView dataSource={treeDataSource}
                      ref={(ref) => treeView = ref}
                      dataStructure="plain"
                      keyExpr="id"
                      parentIdExpr="parent.id"
                      selectionMode="multiple"
                      showCheckBoxesMode="normal"
                      selectNodesRecursive={true}
                      displayExpr="name"
                      selectByClick={true}
                      onContentReady={syncTreeViewSelection}
                      onItemSelectionChanged={treeView_itemSelectionChanged}
                      searchMode={'contains'}
                      searchEnabled={true}
            />
        );
    }

    const yenile = () => {
        setStore(getStore());
    }

    function getTesvkDetayDataInfo(data){
        let propData = {
            domainIdList: [],
            domainAdiList: [],
            donemIdList:[],
            donemAdiList:[],
            domainId :null,
            domainAdi :null
         }

        propData.domainIdList.push(data.personelTesvik.domain.id);
        propData.domainAdiList.push(data.personelTesvik.domain.name);
        propData.donemIdList.push(data.personelTesvik.donem.id);
        propData.donemAdiList.push(data.personelTesvik.donem.donem);
        propData.domainId = propData.domainIdList[0];
        propData.domainAdi = propData.domainAdiList[0];
        propData.success = true;

        return propData;
    }

    function saveTesvikDetay(data) {
        const request = new Request("/tesvikIslemleri/isLogin/" + data.personelTesvik.domain.id, "GET");
        request.run()
            .then(response => {

                let resData = response.data.data;
                if (resData.isbasi && resData.issizlik && resData.isveren) {
                    const request = new Request("/tesvikIslemleri/saveTesvikDetaySgk/" + data.id, "GET");
                    request.run()
                        .then(response => {
                            yenile();
                        });
                } else {

                    let propData = getTesvkDetayDataInfo(data);
                    propData.islem = "login";
                    showTesvikSgkPopup(propData);

                }
            });
    }

    function removeTesvikDetay(data) {
        const request = new Request("/tesvikIslemleri/isLogin/" + data.personelTesvik.domain.id, "GET");
        request.run()
            .then(response => {

                let resData = response.data.data;
                if (resData.isbasi && resData.issizlik && resData.isveren) {
                    const request = new Request("/tesvikIslemleri/removeTesvikDetaySgk/" + data.id, "GET");
                    dispatch(AppActions.setLoading(true,  " Teşvik siliniyor..."));
                    request.run()
                        .then(response => {

                            dispatch(AppActions.setLoading(false, ""));
                            if (response && response.data && response.data.data === true) {
                                yenile();
                            }else if(response && response.response && response.response.data ){
                              let message  =response.response.data.message;
                              showDialog({ title: 'Teşvik Silme Hata', message: message, buttons: "OK" });
                            }

                        });
                } else {

                    let propData = getTesvkDetayDataInfo(data);
                    propData.islem = "login";
                    showTesvikSgkPopup(propData);

                }
            });
    }

    function dateRender(data,b,c) {
        if(data.value){
            //TODO: düzenlecek
            //"28.03.2021"
            // let day = parseInt(data.value.substring(0,2));
            // let month = parseInt(data.value.substring(3,5));
            // let year = parseInt(data.value.substring(6,10));
            // var formatedDate = new Date(year,month-1,day);

            return data.value.substring(6,10) + "/" + data.value.substring(3,5);

        }
        return data.value;
    }

    return (
        <div >
            {
                props.data ? null : <h2 className={'dx-icon-product'}>{listeBasligi}</h2>

            }
            {
                props.data ? null :
                    <div className="dx-field">
                        <div className="buttons" align={'left'} style={{ marginLeft: "10px" }}>
                            <DropDownBox
                                value={treeBoxValue}
                                valueExpr="id"
                                displayExpr="name"
                                placeholder="Firma Seçiniz..."
                                width="350"
                                showClearButton={true}
                                dataSource={treeDataSource}
                                onValueChanged={syncTreeViewSelection}
                                contentRender={treeViewRender}
                            />
                            <DropDownBox
                                value={donemDataValue}
                                valueExpr="id"
                                displayExpr="donem"
                                placeholder="Dönem Seçiniz..."
                                width="350"
                                showClearButton={true}
                                dataSource={donemDataSource}
                            //onValueChanged={syncTreeViewSelection}
                            />

                            <Button icon="search" width={150} text="Yenile" type={'success'} style={{ fontSize: "15px" }}
                                onClick={yenile}></Button>
                        </div>
                    </div>
            }

            <DataGrid
                className={ props.gridClassName ? props.gridClassName : "tesvikDetayListesiGrid"} 
                ref={ref => dataGrid = ref}
                width="100%"
                //height="100%"
                dataSource={store}
                key={"id"}
                keyExpr="id"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                //defaultFocusedRowIndex={0}
                columnAutoWidth={false}
                //columnHidingEnabled={true}
                //onToolbarPreparing={onToolbarPreparing}
                selection={{mode: 'single', deferred:true}}
                remoteOperations={true}>
                <FilterRow visible={true}/>
                <ColumnChooser enabled={true} title={"Kolon Seç"} emptyPanelText={"Buraya Sürükleyiniz..."}/>


                <Pager showPageSizeSelector={true} allowedPageSizes={[5, 10, 20, 50, 100, 200]} showInfo={true}  visible={true} />
                <Paging defaultPageSize={20}/>
                <Column type="buttons" caption={'İşlem'}  width={105}
                        buttons={[
                                {
                                    hint: 'Teşvik Kaydet',
                                    icon: 'save',
                                    visible: (e) => { return e.row.data.tesvikSgkOnay !== true && formYetki.sgkLogin && formYetki.tesvikKaydet},
                                    onClick: (e) => { saveTesvikDetay(e.row.data);}
                                },
                                {
                                    hint: 'Teşvik Sil',icon: 'remove',
                                    visible: (e) => { return e.row.data.tesvikSgkOnay == true && formYetki.sgkLogin && formYetki.tekTesvikSil},
                                    onClick: (e) => { removeTesvikDetay(e.row.data);}
                                },
                                {
                                    hint: 'Başlangıç / bitiş tarihi güncelle',
                                    icon: 'edit',
                                    visible: () => formYetki.tesvikTarihGuncelle,
                                    onClick: (e) => { showTarihGuncellePopup(e.row.data); },
                                },
                        ]}
                />
                <Column dataField={'id'} width={90} caption={'Id'} dataType="number" mappingType="int" visible={false}/>
                <Column dataField={'personelTesvik.domain.name'} minWidth={90} width={180} caption={'Domain'} dataType="string"
                        mappingType="String" visible={true}/>
                <Column dataField={'personelTesvik.personel.tcKimlikNumarasi'} width={90} caption={'Tck No'} dataType="string"
                        mappingType="String" visible={true}/>

                <Column dataField={'personelTesvik.personel.adi'} width={90} caption={'Adı'} dataType="string" mappingType="String"
                        visible={true}/>
                <Column dataField={'personelTesvik.personel.soyadi'} width={90} caption={'Soyadi'} dataType="string" mappingType="String" visible={true}/>

                <Column dataField="personelTesvik.donem.donem" width={70} caption={'Dönem'} dataType="string" mappingType="String"
                        visible={true} defaultSortOrder="desc"/>

                <Column dataField={'tesvikSuresi'} width={70} caption={'Teşvik Süresi'} dataType="number" visible={true}
                        mappingType="int"/>

                <Column dataField="personelTesvik.iseGirisTarihi" width={80} caption={'İşe Giriş'} dataType="date" format="yyyy/MM" visible={true}
                        mappingType="Date" format="yyyy/MM/dd"
                />
                        
                <Column dataField="baslangicDonemi" width={70} caption={'Başlangıç'} dataType="date" format="yyyy/MM" visible={true}  
                        //mappingType="Date" format="yyyy/MM"
                        />

                <Column dataField="bitisDonemi" width={70} caption={'Bitiş'} dataType="date" format="yyyy/MM" visible={true} 
                        //mappingType="Date" format="dd.MM.yyyy"
                        />
                <Column dataField={'tesvikKanunu.kanunNumarasi'} width={70} caption={'Kanun-No'} dataType="number" visible={true}
                        mappingType="int" />

                <Column dataField={'ilaveOlunacakSayi'} width={70} caption={'İlave Olnucak Sayı'} dataType="number" visible={true}
                        mappingType="double"/>

                <Column dataField={'egitim.adi'} width={70} caption={'Eğitim'} dataType="string" visible={true}
                        mappingType="String"/>

                <Column dataField={'personelTesvik.meslek.kodu'} width={70} caption={'Meslek Kodu'} dataType="string" visible={true}
                        mappingType="String"/>
                {/* <Column dataField={'kazanc'} width={70} caption={'Kazanç'} dataType="number" visible={true}
                        mappingType="double"/>

                <Column dataField={'tesviksizOdenecekTutar'} width={80} caption={'Teşviksiz Tutar'} dataType="number" visible={true}
                        mappingType="double"/>

                <Column dataField={'tesvikTutari'} width={80} caption={'Teşvik Tutar'} dataType="number" mappingType="double"
                        visible={true}/> */}

                <Column dataField={'tesvikSgkOnay'} width={80} caption={'Onay'} dataType="boolean" mappingType="bool"
                        visible={true}/>

                <Column dataField={'mesaj'} width={80} caption={'Mesaj'} dataType="string" mappingType="String"
                        visible={true}/>


                <Column dataField={'personelTesvik.personel.sosyalGuvenlikNumarasi'} width={90} caption={'SGK No'} dataType="string"
                    mappingType="String"
                    visible={false} />

                <Column dataField={'onayMesaj'} width={90} caption={'Onay Mesaj'} dataType="string"
                    mappingType="String"
                    visible={true} />

                 <Column dataField={'personelTesvik.emekli'} width={80} caption={'Emekli'} dataType="boolean" mappingType="bool"
                        visible={true}/>

            

            </DataGrid>

            <Popup
                visible={tesvikDetayData.popupState}
                onHiding={hideTesvikSgkPopup}
                dragEnabled={false}
                closeOnOutsideClick={false}
                showTitle={true}
                title="Sgk Login işlemleri"
                width={300}
                height={200}
            >
                <div>
                    {tesvikDetayData.popupState ? <TesvikLoginIslemleri data={tesvikDetayData.data} hide={hideTesvikSgkPopup}/> : null}
                </div>
            </Popup>

            <Popup
                visible={tarihGuncelleState.popupState}
                onHiding={hideTarihGuncellePopup}
                dragEnabled={false}
                closeOnOutsideClick={true}
                showTitle={true}
                title="Teşvik başlangıç / bitiş tarihi"
                width={420}
                height={340}
            >
                <div>
                {tarihGuncelleState.popupState ? (
                    <div className="dx-fieldset" style={{ padding: "8px", minHeight: 220 }}>
                        <div className="dx-field">
                            <div className="dx-field-label">Başlangıç dönemi</div>
                            <div className="dx-field-value">
                                <DateBox
                                    value={tarihGuncelleState.baslangicDonemi}
                                    onValueChanged={(e) =>
                                        setTarihGuncelleState((s) => ({ ...s, baslangicDonemi: e.value }))
                                    }
                                    type="datetime"
                                    displayFormat="dd.MM.yyyy HH:mm"
                                    showClearButton={true}
                                    width="100%"
                                />
                            </div>
                        </div>
                        <div className="dx-field">
                            <div className="dx-field-label">Bitiş dönemi</div>
                            <div className="dx-field-value">
                                <DateBox
                                    value={tarihGuncelleState.bitisDonemi}
                                    onValueChanged={(e) =>
                                        setTarihGuncelleState((s) => ({ ...s, bitisDonemi: e.value }))
                                    }
                                    type="datetime"
                                    displayFormat="dd.MM.yyyy HH:mm"
                                    showClearButton={true}
                                    width="100%"
                                />
                            </div>
                        </div>
                        <div className="dx-field">
                            <div className="dx-field-label">Emekli</div>
                            <div className="dx-field-value">
                                <CheckBox
                                    value={tarihGuncelleState.emekli}
                                    onValueChanged={(e) =>
                                        setTarihGuncelleState((s) => ({ ...s, emekli: e.value }))
                                    }
                                    enableThreeStateBehavior={true}
                                />
                            </div>
                        </div>
                        <div className="buttons" style={{ marginTop: "16px", textAlign: "right" }}>
                            <Button text="İptal" onClick={hideTarihGuncellePopup} style={{ marginRight: "8px" }} />
                            <Button text="Güncelle" type="success" onClick={kaydetTesvikTarih} />
                        </div>
                    </div>
                ) : null}
                </div>
            </Popup>

        </div>
    )
}

export default TesvikDetayIslemleri;
